import { createFileRoute } from "@tanstack/react-router";
import { BygherreraadgivningPage, bygherreraadgivningHead } from "@/pages/BygherreraadgivningPage";

export const Route = createFileRoute("/de/bauherrenberatung")({
  head: () => bygherreraadgivningHead("de"),
  component: () => <BygherreraadgivningPage locale="de" />,
});
